module.exports = __webpack_public_path__ + "media/images/orbit/left-arrow-5773b6536524a3cb95ee787886fcb0c557668bff8198385fb0fa717384a78d5e.png";